import { Fragment } from 'react';

import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';
import HideIcon from '@usas/ui-web/components/icons/HideIcon';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const DetailTableRow = ({ roles }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={[global.SmallTableRowData, 'col-xs-12'].join(' ')}>{roles.goodStandingName}</div>
      </div>
    </div>
  </div>
);

const GridRowDetailTable = ({ course }) => (
  <div className={global.SmallTableDetailTable}>
    <div className={[global.SmallTableDetailRowHead, 'col-xs-12'].join(' ')}>
      Good Standing Types
    </div>
    {Array.isArray(course.goodStandingType) && course.goodStandingType.map((roles, i) => <DetailTableRow key={i} roles={roles} />)}
  </div>
);

const GridRow = ({ course, formState, expandedId, onClick }) => {
  const courseGoodStandingRole = Array.isArray(course.goodStandingType)
    ? course.goodStandingType.find(x => x.goodStandingName === formState.goodStandingName)
    : null;

  return (
    formState.goodStandingName === courseGoodStandingRole?.goodStandingName
      ? <Fragment>
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}><span className='hidden-xs'>{course.courseName} {course.courseCode ? `(${course.courseCode})` : ''}</span>&nbsp;
            <button className={global.IconButton}
              type="button"
              onClick={(e) => onClick(e, course.lmsCourseId)}>
              {expandedId === course.lmsCourseId ? <HideIcon /> : <ShowIcon />}
            </button>
          </div>
          <div className={[global.SmallTableRowInfo, 'visible-xs'].join('')}>
            <div className='row'>
              <div className={[global.SmallTableRowLabels, 'col-xs-6 hidden-sm'].join(' ')}>Requirement</div>
              <div className={[global.SmallTableRowData, 'col-xs-6 hidden-sm'].join(' ')}>{course.courseName} {course.courseCode ? `(${course.courseCode})` : ''}</div>
              <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Date Completed</div>
              <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>
                {course.courseCompletionDate !== null
                  ? formatDate(course.courseCompletionDate) === Constants.DEFAULT_MAX_DATE
                    ? <span>&nbsp;</span>
                    : formatDate(course.courseCompletionDate)
                  : <span>&nbsp;</span>}</div>
              <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Expiration Date</div>
              <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>
                {course.courseExpirationDate !== null
                  ? formatDate(course.courseExpirationDate) === Constants.DEFAULT_MAX_DATE
                    ? `Doesn't Expire`
                    : formatDate(course.courseExpirationDate)
                  : <span>&nbsp;</span>
                }
              </div>
              <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Status</div>
              <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>
                {course.status}
              </div>
            </div>
          </div>
        </div>
        {Array.isArray(course.goodStandingType) && course.goodStandingType.length > 0
          && expandedId === course.lmsCourseId &&
          <GridRowDetailTable course={course} />
        }
      </Fragment>
      : <Fragment />
  );
};

const MemberRequirementsSmallReadGrid = ({ gridData, isLoading, formState, expandedId, onClick }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (<div className={global.SmallTableRow}>
        <div className={global.SmallTableRowHead}>&nbsp;</div>
        <div className={global.SmallTableRowInfo}>
          <div className={global.SmallTableRowLabels}>
            Loading...
          </div>
        </div>
      </div>
      )
      : Array.isArray(gridData) && gridData.length > 0
        ? gridData.map((course, i) =>
          <GridRow key={i}
            course={course}
            formState={formState}
            expandedId={expandedId}
            onClick={onClick} />)
        : (<div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>
              No Requirements
            </div>
          </div>
        </div>
        )
    }
  </div>
);

export default MemberRequirementsSmallReadGrid;